export default __webpack_public_path__ + "static/CreerFeatureSeven-2765c8a00a90cdccf2bb8ccd115a9fba.webp";